import { combineReducers } from 'redux';
import { TestReducer } from './TestReducer';
import { TrashReducer } from './TrashReducer';
import { MessagesReducer } from './MessagesReducer';
import { SettingsReducer } from './SettingsReducer';
import { TrialReducer } from './TrialReducer';

export const RootReducer = combineReducers({
  test: TestReducer,
  trash: TrashReducer,
  settings: SettingsReducer,
  messages: MessagesReducer,
  trial: TrialReducer,
});
